"use client"

import dynamic from "next/dynamic"
import { useState } from "react"
import AppIcon from "@/app/components/atomic/AppIcon"

const LoanInsuranceCallbackModal = dynamic(() => import("./LoanInsuranceCallbackModal"))

export default function LoanInsuranceCallbackLink({ className = "" }: { className?: string }) {
    const [isModalOpen, setIsModalOpen] = useState(false)

    return (
        <div className={`flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-sm text-pale ${className}`}>
            <span className="whitespace-nowrap">Vous préférez en parler ?</span>

            <button
                type="button"
                onClick={() => setIsModalOpen(true)}
                data-test="callback-cta"
                className="flex cursor-pointer items-center gap-2 whitespace-nowrap font-bold text-rm-blue-deep underline hover:opacity-80"
            >
                <AppIcon iconClassName="fa-phone" size="sm" />
                Être rappelé par un conseiller
            </button>

            {isModalOpen && <LoanInsuranceCallbackModal onClose={() => setIsModalOpen(false)} />}
        </div>
    )
}
